class ExternalPriceBucketFilter extends window.BAO.CustomElement({
  SuperClass: HTMLFormElement,
}) {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.querySelectorAll('input').forEach(input => {
      input.addEventListener('input', this.onInput.bind(this))
    })
  }

  onInput (e) {
    if (!e.target?.name || !e.target?.value) return

    document.querySelector('.clc-ProductGridFacetsTablet').dispatchEvent(
      new CustomEvent('collection-filters:price-bucket-filter', {
        detail: {
          filterKey: e.target.name,
          filterValue: e.target.value,
          checked: e.target.checked,
        },
        bubbles: true,
      }),
    )
  }
}

if (!window.customElements.get('external-price-bucket-filter')) {
  window.customElements.define(
    'external-price-bucket-filter',
    ExternalPriceBucketFilter,
    { extends: 'form' },
  )
}
